import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate, useLocation } from 'react-router-dom'
import { selectIsAdmin, selectCanManage } from '../../store/slices/authSlice'

const ProtectedRoute = ({ 
  children, 
  requireAdmin = false, 
  requireEditor = false,
  redirectTo = '/admin/login' 
}) => {
  const { isAuthenticated, isLoading } = useSelector(state => state.auth)
  const isAdmin = useSelector(selectIsAdmin)
  const canManage = useSelector(selectCanManage)
  const location = useLocation()
  
  // Показываем загрузку пока проверяем аутентификацию
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    )
  }
  
  // Если не аутентифицирован, перенаправляем на логин
  if (!isAuthenticated) {
    return <Navigate to={redirectTo} state={{ from: location }} replace />
  }
  
  // Проверяем права доступа
  if (requireAdmin && !isAdmin) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-red-600 mb-4">Доступ запрещен</h2>
          <p className="text-gray-600 mb-4">
            У вас нет прав для доступа к этой странице
          </p>
          <button
            onClick={() => window.history.back()}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Назад
          </button>
        </div>
      </div>
    )
  }
  
  if (requireEditor && !canManage) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-red-600 mb-4">Доступ запрещен</h2>
          <p className="text-gray-600 mb-4">
            У вас нет прав редактора для доступа к этой странице
          </p>
          <button
            onClick={() => window.history.back()}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Назад
          </button>
        </div>
      </div>
    )
  }
  
  return children
}

export default ProtectedRoute